import firebase from "firebase";

export default {
  namespaced: true,

  state: {
    // 全グループ情報
    groups: [],
  },

  mutations: {
    // 全ユーザー情報を取得します.
    addGroup(state: any, group: any) { state.groups.push(group) },
    // 全ユーザー情報を削除します.
    resetGroups(state: any) { state.groups = []; },
    // state内のグループメンバー情報を更新します.
    updateGroupMember(state: any, updateGroupMemberInfo: any) {
      state.groups.some((group: any) => {
        if (group.groupId === updateGroupMemberInfo.groupId) {
          group.groupMembers.push({
            groupInsertDate: new Date,
            userId: updateGroupMemberInfo.loginUserId
          })
          return true;
        }
      });
      alert("グループ「" + updateGroupMemberInfo.groupName + "」に参加しました。");
      return true;
    }
  },

  actions: {
    // 友達申請を中止します.
    discontinueGroups({ rootGetters }: any, { groupId, groupName }: any) {
      firebase.firestore().collection("users").doc(rootGetters.loginUserId).collection("groups").doc(groupId).delete()
      .then(() => {
        firebase.firestore().collection("groups").doc(groupId).collection("members").doc(rootGetters.loginUserId).delete();
        alert(groupName + " への参加申請を中止しました。");
      })
      .catch((error) => {
        console.error("Error removing document: ", error);
      });
    },
    // 全グループ情報を取得します.
    fetchGroups({ commit }: any) {
      commit("resetGroups");
      const groupsRef = firebase.firestore().collection("groups");
      const promise = groupsRef.orderBy("groupName").get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const group = doc.data();
          const groupMembers: any = [];
          groupsRef.doc(group.groupId).collection("members").get()
          .then(querySnapshot => querySnapshot.forEach(doc => {
            groupMembers.push(doc.data());
            group.groupMembers = groupMembers;
          }));
          commit("addGroup", group);
        });
      });
      return Promise.resolve(promise);
    },
    // state内のグループメンバー情報を更新します.
    updateGroupMember({ commit, rootGetters }: any, group: any) {
      if (confirm("グループ「" + group.groupName + "」に参加しますか？")) {
        const updateGroupMemberInfo = {
          loginUserId: rootGetters.loginUserId,
          groupId: group.groupId,
          groupName: group.groupName
        }
        commit("updateGroupMember", updateGroupMemberInfo);
      } else {
        return false;
      }
    }
  },

  getters: {
    // 全グループ情報
    groups: (state: any) => (state.groups ? state.groups : ""),
  },
};
